import script from "./contactus.vue?vue&type=script&setup=true&lang=js"
export * from "./contactus.vue?vue&type=script&setup=true&lang=js"

import "./contactus.vue?vue&type=style&index=0&id=790788b3&lang=css"

const __exports__ = script;

export default __exports__